<template>
	<a
		v-if="$data.componentActive"
		class="button button-primary"
		:href="$data.base_href + $props.add_query"
		download
		:title="$data.buttonTitle"
		data-test-id="report-excel"
		@click="$emit('started')"
	>
		{{ $data.buttonText }}
		<svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M15 2H3V16H15V2ZM10.5458 12.4286H12.4286L10.0002 8.91158L12.3002 5.57143H10.5458L9.06953 7.88989H9.03744L7.58257 5.57143H5.6891L7.96768 8.88211L5.57143 12.4286H7.32583L8.89837 9.90381H8.93047L10.5458 12.4286Z" fill="white"/>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M2 1H14V0H1V15H2V1Z" fill="white"/>
		</svg>
	</a>
</template>

<script>
	import urlUtil from '../../util-url.js'

	/**
	 * Компонент отчета в Excel: armMeta.reportOptions
	 */
	export default {
		name: 'ReportExcel',
		props: {
			options: {
				required: true,
			},
			show_context: {
				required: true,
				type: String,
			},
			arm_id: {
				required: true,
				type: Number,
			},
			add_query: {
				required: false,
				type: String,
				default: '',
			},
			record_id: {
				required: false,
			},
		},
		data: function() {
			var opt = this.$props.options;
			if (!opt) {
				return {
					componentActive: false
				}
			}
			var contextSuitable = opt.showInContext === 'CARD_AND_LIST';
			if (this.$props.show_context === 'CONTEXT_LIST' && (opt.showInContext === 'LIST_ONLY' || typeof opt.showInContext === 'undefined')) { // undefined потому что showInContext новое свойство и не проставлено у АРМ
				contextSuitable = true;
			}
			if (this.$props.show_context === 'CONTEXT_CARD' && opt.showInContext === 'CARD_ONLY' && this.$props.record_id) {
				// проверка на record_id - чтобы не показывать кнопку при создании новой записи
				contextSuitable = true;
			}
			var componentActive = opt.queries && opt.queries.length && contextSuitable;

			var addQuery = '';
			if (this.$props.show_context === 'CONTEXT_CARD' && this.$props.record_id) {
				addQuery = '?id=' + this.$props.record_id;
			}

			var base_href = urlUtil.getServiceUrl({
				methodName: 'report',
				armId: this.$props.arm_id,
				vpId: this.$route.params.vpId,
				context: this.$props.show_context,
				addQuery,
			});

			return {
				base_href,
				componentActive,
				/** Тайтл кнопки */
				buttonTitle: 'Отчёт Excel',
				/** Текст в самой кнопке */
				buttonText: opt.buttonName || '',
			}
		}
	}
</script>
